/**
 * Metadata de pre-login por dominio dedicado (titulo, favicon, slug, splash).
 * Fuente unica para index.html (script temprano), WhiteLabelService y environment overrides.
 * Cliente nuevo: añadir entrada aqui + slug en ALLOWED_LOGIN_ROUTES (white-label.service).
 */
export interface HostPreLoginBootstrapEntry {
  slug: string;
  title: string;
  faviconUrl: string;
  loginLogoUrl: string;
  /** Fondo del splash de carga (alineado con login-white-label-panel). */
  splashBgColor?: string;
}

export const HOST_PRE_LOGIN_BOOTSTRAP: Record<string, HostPreLoginBootstrapEntry> = {
  'dashboard.mts.com.co': {
    slug: 'mts',
    title: 'MTS | Dashboard',
    faviconUrl:
      'https://munily-public-cdn.s3.us-east-1.amazonaws.com/faceRecognition/customized/Mts/LogoM.jpg',
    loginLogoUrl:
      'https://munily-public-cdn.s3.us-east-1.amazonaws.com/faceRecognition/customized/Mts/mtsLetterLogo.svg',
    splashBgColor: '#1a1a2e',
  },
};

export function getHostPreLoginBootstrap(
  hostname: string,
  envHosts: Record<string, HostPreLoginBootstrapEntry> = {},
): HostPreLoginBootstrapEntry | null {
  const host = hostname.toLowerCase();
  return envHosts[host] ?? HOST_PRE_LOGIN_BOOTSTRAP[host] ?? null;
}

/** Quita el splash inyectado en index (host-pre-login-bootstrap.js). */
export function removeHostPreLoginSplash(): void {
  if (typeof window === 'undefined') {
    return;
  }
  const remover = (window as Window & { __munilyRemoveHostPreLoginSplash?: () => void })
    .__munilyRemoveHostPreLoginSplash;
  if (typeof remover === 'function') {
    remover();
  }
}
